import React from 'react';
import { View, Text, TouchableOpacity, Image } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';

const ReportCardFile = ({ report, isSelected, onPress, onLongPress, onEdit, onDelete }) => {
    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved':
                return '#2ecc71';
            case 'pending':
                return '#f1c40f';
            case 'rejected':
                return '#e74c3c';
            default:
                return '#95a5a6';
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        if (timestamp.toDate) {
            return timestamp.toDate().toLocaleDateString();
        }
        return new Date(timestamp).toLocaleDateString();
    };

    return (
        <View
            style={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                padding: 8,
                minHeight: 200,
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 4,
            }}
        >
            {/* Header with venue name and status */}
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: 8
            }}>
                <Text style={{
                    fontFamily: 'VastagoGrotesk',
                    fontSize: 10,
                    fontWeight: 'bold',
                    color: '#2c3e50',
                    flex: 1,
                    marginRight: 8
                }} numberOfLines={1}>
                    {report.venueName || 'Unknown Venue'}
                </Text>
                
                <View style={{ flexDirection: 'row', gap: 4 }}>
                    {report.isTechSpecsOnly && (
                        <Text style={{
                            backgroundColor: '#0bb5df',
                            color: 'white',
                            fontSize: 9,
                            fontFamily: 'VastagoGrotesk',
                            paddingHorizontal: 6,
                            paddingVertical: 2,
                            borderRadius: 4
                        }}>
                            TECH SPECS
                        </Text>
                    )}
                    <Text style={{
                        backgroundColor: getStatusColor(report.status),
                        color: 'white',
                        fontSize: 9,
                        fontFamily: 'VastagoGrotesk',
                        paddingHorizontal: 6,
                        paddingVertical: 2,
                        borderRadius: 4
                    }}>
                        {report.status?.toUpperCase() || 'UNKNOWN'}
                    </Text>
                </View>
            </View>

            {/* Content area */}
            <View style={{ flex: 1 }}>
                {/* Date */}
                <Text style={{
                    fontFamily: 'Glacial Indifference',
                    fontSize: 9,
                    color: '#7f8c8d',
                    marginBottom: 8
                }}>
                    Submitted: {formatDate(report.createdAt)}
                </Text>

                {/* User type specific fields */}
                {report.userType === 'artist' && (
                    <>
                        <Text style={{
                            fontFamily: 'Glacial Indifference',
                            fontSize: 9,
                            color: '#34495e',
                            marginBottom: 4
                        }} numberOfLines={1}>
                            Performance Date: {report.dateOfPerformance || 'N/A'}
                        </Text>
                        <Text style={{
                            fontFamily: 'Glacial Indifference',
                            fontSize: 9,
                            color: '#34495e',
                            marginBottom: 4
                        }} numberOfLines={1}>
                            Band Name: {report.bandName || 'N/A'}
                        </Text>
                    </>
                )}

                {report.userType === 'employee' && (
                    <>
                        <Text style={{
                            fontFamily: 'Glacial Indifference',
                            fontSize: 9,
                            color: '#34495e',
                            marginBottom: 4
                        }} numberOfLines={1}>
                            Dates Worked: {report.datesWorked || 'N/A'}
                        </Text>
                        <Text style={{
                            fontFamily: 'Glacial Indifference',
                            fontSize: 9,
                            color: '#34495e',
                            marginBottom: 4
                        }} numberOfLines={1}>
                            Job Title: {report.jobTitle || 'N/A'}
                        </Text>
                    </>
                )}

                {report.userType === 'touring' && (
                    <Text style={{
                        fontFamily: 'Glacial Indifference',
                        fontSize: 9,
                        color: '#34495e',
                        marginBottom: 4
                    }} numberOfLines={1}>
                        Job Title: {report.jobTitle || 'N/A'}
                    </Text>
                )}

                {/* Notes preview */}
                {report.notes && (
                    <Text style={{
                        fontFamily: 'Glacial Indifference',
                        fontSize: 9,
                        color: '#34495e',
                        marginBottom: 8
                    }} numberOfLines={2}>
                        Notes: {report.notes}
                    </Text>
                )}

                {/* Action buttons */}
                <View style={{
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginTop: 10,
                    gap: 10
                }}>
                    {report.status === 'pending' && onEdit && (
                        <TouchableOpacity
                            style={{
                                backgroundColor: '#2ecc71',
                                paddingVertical: 5,
                                paddingHorizontal: 10,
                                borderRadius: 5
                            }}
                            onPress={() => onEdit(report)}
                        >
                            <Text style={{
                                color: 'white',
                                fontFamily: 'VastagoGrotesk',
                                fontSize: 9
                            }}>
                                Edit
                            </Text>
                        </TouchableOpacity>
                    )}

                    {onDelete && (
                        <TouchableOpacity
                            style={{
                                backgroundColor: '#e74c3c',
                                paddingVertical: 5,
                                paddingHorizontal: 10,
                                borderRadius: 5
                            }}
                            onPress={() => onDelete(report)}
                        >
                            <Text style={{
                                color: 'white',
                                fontFamily: 'VastagoGrotesk',
                                fontSize: 9
                            }}>
                                Delete
                            </Text>
                        </TouchableOpacity>
                    )}
                </View>
            </View>

            {/* Gradient overlay for visual appeal */}
            <LinearGradient
                colors={['rgba(255,255,255,0)', 'rgba(0,0,0,0.05)']}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 20,
                    borderBottomLeftRadius: 12,
                    borderBottomRightRadius: 12
                }}
            />
        </View>
    );
};

export { ReportCardFile };